module.exports = __webpack_public_path__ + "img/wj_banner_jskh.fcf6f9f4.png";